import {CalendarBar, Dropdown, QuestionTooltip, Tab} from "omoplay";
import {useEffect, useState} from "react";
import moment from "moment/moment";
import {getAllDateRange, getDefaultDateRange} from "../../libs/helper";
import {getDetailEventsToProject} from "../../api/project/project.api";
import {getEntryPointBenefits, getSpotStatistics} from "../../api/statistics/statistics.api";
import InputGroup from "./InputGroup";
import EChartsReact from "echarts-for-react";
import {basicBarOption} from "../../constants/chart_config";
import ArrowDownBlueIcon from "../../assets/images/icon.arrow.down.blue.svg"

const EntryPointStatistics = ({periodStartDate, projectId}) => {
    const [dateRange, setDateRange] = useState(getDefaultDateRange())
    const [spots, setSpots] = useState([])
    const [spotId, setSpotId] = useState()
    const [spotStatistics, setSpotStatistics] = useState({})
    const [entryPointBenefits, setEntryPointBenefits] = useState([])

    const dateItems = [
        { value: "all", label: "전체" },
        { value: "month", label: "최근 한 달" },
        { value: "week", label: "최근 일주일", selected: true },
    ];
    const handleQuickChange = (type) => {
        const format = "YYYY-MM-DD"
        const allDateRange = getAllDateRange()

        if (type === "all") {
            setDateRange({
                startDate: (periodStartDate ? moment(periodStartDate) : allDateRange.startDate).format(format),
                endDate: allDateRange.endDate,
            })
        } else if (type === "month") {
            setDateRange({
                startDate: moment().subtract(1, "month").format(format),
                endDate: allDateRange.endDate,
            })
        } else if (type === "week") {
            setDateRange({
                startDate: moment().subtract(6, "days").format(format),
                endDate: allDateRange.endDate,
            })
        }
    };
    const onDateInput = (dateRange) => {
        setDateRange({
            startDate: moment(dateRange.startDate).format("yyyy-MM-DD"),
            endDate: moment(dateRange.endDate).format("yyyy-MM-DD")
        });
    };
    useEffect(() => {
        getDetailEventsToProject(projectId).then(({data}) => {
            const events = data.events
            const spots = events.flatMap(event => event.entryPoints, [])
            setSpots([
                {
                    name: "전체"
                }, ...spots
            ])
        })
    }, [projectId]);

    useEffect(() => {
        const { startDate, endDate } = dateRange;
        getSpotStatistics(projectId, spotId, startDate, endDate).then(({data}) => {
            setSpotStatistics(data)
        })
    }, [projectId, spotId, dateRange])

    useEffect(() => {
        const { startDate, endDate } = dateRange;
        getEntryPointBenefits(projectId, startDate, endDate).then(({data}) => {
            setEntryPointBenefits(data)
        })
    }, [dateRange])

    return (
        <div className="flex-col gap-4 bg-white p-4">
            <div className="flex gap-2">
                <div>
                    <Tab
                        variants="input"
                        items={dateItems}
                        onChanged={(data) => handleQuickChange(data.value)}
                    />
                </div>
                <CalendarBar initDate={{startDate: moment(dateRange.startDate).toDate(), endDate: moment(dateRange.endDate).toDate()}}
                             multiple={true}
                             onConfirm={(props) => onDateInput(props)} />
            </div>
            {
                entryPointBenefits.length > 0 && (
                    <InputGroup label="진입점별 혜택 사용 수">
                        <EChartsReact
                            option={
                                basicBarOption(
                                    entryPointBenefits.map(benefit => benefit.spotName),
                                    entryPointBenefits.map(benefit => benefit.count),
                                    "명")
                            }
                        />
                    </InputGroup>
                )
            }
            <InputGroup label="페이지별 조회 통계">
                <div className="flex items-center" style={{marginBottom: "15px", gap: "12px"}}>
                    <div>
                        {
                            spots.length > 0 ?
                                <Dropdown variants="default"
                                          style={{width: "200px"}}
                                          titleStyle={{backgroundColor: "white"}}
                                          items={spots.map(spot => ({label: spot.name, value: spot.id}))}
                                          onChanged={(items) => {
                                              setSpotId(items[0].value)
                                          }} /> : <></>
                        }
                    </div>
                </div>
                <div className="spot-table">
                    <div>
                        <div className="flex-align-center">
                            <div className="w-1/2 flex-1">
                                <EChartsReact
                                    option={basicBarOption(
                                        [
                                            "메인 페이지 진입", "로그인 버튼 클릭",
                                            "이벤트 페이지 진입", "이벤트 클릭"

                                        ],
                                        [
                                            spotStatistics?.mainPageCount, spotStatistics?.loginCount,

                                            spotStatistics?.eventPageCount, spotStatistics?.eventJoinCount
                                        ], "명")}
                                />
                            </div>
                        </div>
                        <div className="flex-align-center w-full">
                            <div className="flex-center-all flex-1 w-full h-[150px]"><img width={100} src={ArrowDownBlueIcon} /></div>
                        </div>
                        <div className="flex-center-all flex-1">
                            <div className="w-1/2">
                                <EChartsReact
                                    option={basicBarOption(
                                        [
                                            "미선택 페이지 진입", "재가입",
                                        ],
                                        [
                                            spotStatistics?.uncheckedPageCount, spotStatistics?.uncheckedLoginCount,
                                        ], "명")}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="spot-header">
                        <div className="flex-1 text-left">
                            <span className="number-badge" style={{marginRight: "5px"}}>1</span>
                            <span className="font-semibold" style={{color: "var(--color-foreground-tertiary)"}}>메인 페이지</span>
                        </div>
                        <div className="flex-1 text-left">
                            <span className="number-badge" style={{marginRight: "5px"}}>2</span>
                            <span className="font-semibold" style={{color: "var(--color-foreground-tertiary)"}}>미선택 체크 경고 페이지</span>
                        </div>
                        <div className="flex-1 text-left">
                            <span className="number-badge" style={{marginRight: "5px"}}>3</span>
                            <span className="font-semibold" style={{color: "var(--color-foreground-tertiary)"}}>이벤트 페이지</span>
                        </div>
                        <div className="flex-1 text-left ">
                            <span className="number-badge" style={{marginRight: "5px"}}>4</span>
                            <span className="font-semibold" style={{color: "var(--color-foreground-tertiary)"}}>당첨 화면</span>
                        </div>
                    </div>
                    <div className="spot-row">
                        <div className="spot-row-item row-data">
                            <div >
                                <span className="rectangle" style={{marginRight: "10px"}} />
                                <span>메인 페이지 진입</span>
                            </div>
                            <div className="counting-text">
                                <span>{spotStatistics?.mainPageCount?.toLocaleString()}</span>
                                <span>명</span>
                            </div>
                        </div>
                        <div className="spot-row-item row-data">
                            <div>
                                <span className="rectangle" style={{marginRight: "10px"}} />
                                <span>미선택 페이지 진입</span>
                            </div>
                            <div className="counting-text">
                                <span>{spotStatistics?.uncheckedPageCount?.toLocaleString()}</span>
                                <span>명</span>
                            </div>
                        </div>
                        <div className="spot-row-item row-data">
                            <div>
                                <span className="rectangle" style={{marginRight: "10px"}} />
                                <span>이벤트 페이지 진입</span>
                            </div>
                            <div className="counting-text">
                                <span>{spotStatistics?.eventPageCount?.toLocaleString()}</span>
                                <span>명</span>
                            </div>
                        </div>
                        <div className="spot-row-item">
                            <div style={{width: "100%"}}>
                                {
                                    spotStatistics?.prizeButtons?.map((button) => {
                                        return (
                                            <div className="row-data">
                                                <div>
                                                    <span className="rectangle" style={{marginRight: "10px"}} />
                                                    <span>{button.name}</span>
                                                </div>
                                                <div className="counting-text">
                                                    <span>{button.count}</span>
                                                    <span>명</span>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                    <div className="spot-row">
                        <div className="spot-row-item row-data">
                            <div>
                                <span className="rectangle" style={{marginRight: "10px"}} />
                                <span>로그인 버튼 클릭</span>
                            </div>
                            <div className="counting-text">
                                <span>{spotStatistics?.loginCount?.toLocaleString()}</span>
                                <span>명</span>
                            </div>
                        </div>
                        <div className="spot-row-item row-data">
                            <div>
                                <span className="rectangle" style={{marginRight: "10px"}} />
                                <span>재가입</span>
                            </div>
                            <div className="counting-text">
                                <span>{spotStatistics?.uncheckedLoginCount?.toLocaleString()}</span>
                                <span>명</span>
                            </div>
                        </div>
                        <div className="spot-row-item row-data">
                            <div>
                                <span className="rectangle" style={{marginRight: "10px"}} />
                                <span>룰렛 클릭</span>
                            </div>
                            <div className="counting-text">
                                <span>{spotStatistics?.eventJoinCount?.toLocaleString()}</span>
                                <span>명</span>
                            </div>
                        </div>
                        <div className="spot-row-item">
                        </div>
                    </div>
                    <div className="spot-row">
                        <div className="spot-row-item row-data" style={{backgroundColor: "var(--color-shape-depth1)"}}>
                            <div className="row-data">
                                <div>로그인 전환율</div>
                                <div><QuestionTooltip>로그인 버튼 클릭 수 / 페이지 조회 수</QuestionTooltip> </div>
                            </div>
                            <div className="percent-text">
                                <span>{spotStatistics.mainPageConversionRate}</span>
                                <span>%</span>
                            </div>
                        </div>
                        <div className="spot-row-item row-data" style={{backgroundColor: "var(--color-shape-depth1)"}}>
                            <div className="row-data">
                                <div>재가입 전환율</div>
                                <div><QuestionTooltip >재가입 수 / 페이지 조회 수</QuestionTooltip></div>
                            </div>
                            <div className="percent-text">
                                <span>{spotStatistics.uncheckedConversionRate}</span>
                                <span>%</span>
                            </div>
                        </div>
                        <div className="spot-row-item row-data" style={{backgroundColor: "var(--color-shape-depth1)"}}>
                            <div className="row-data">
                                <div>참여 전환율</div>
                                <div><QuestionTooltip >룰렛 클릭 수 / 페이지 조회 수</QuestionTooltip></div>
                            </div>
                            <div className="percent-text">
                                <span>{spotStatistics.eventPageConversionRate}</span>
                                <span>%</span>
                            </div>
                        </div>
                        <div className="spot-row-item row-data" style={{backgroundColor: "var(--color-shape-depth1)"}}>
                            <div className="row-data">
                                <div>실 전환율</div>
                                <div><QuestionTooltip >이벤트 페이지 룰렛 클릭 수 / 메인 페이지 조회 수</QuestionTooltip></div>
                            </div>
                            <div className="percent-text">
                                <span>{spotStatistics.totalConversionRate}</span>
                                <span>%</span>
                            </div>
                        </div>
                    </div>
                </div>
            </InputGroup>
        </div>
    )
}

export default EntryPointStatistics